import { Controller } from '@hotwired/stimulus';

export default class PasswordVisibilityController extends Controller {
  static targets = ['input', 'showIcon', 'hideIcon']

  toggle() {
    if (this.inputTarget.type === 'password') {
      this.inputTarget.type = 'text';
      this.toggleClass();
      this.hideIconTarget.focus();
    } else {
      this.inputTarget.type = 'password';
      this.toggleClass();
      this.showIconTarget.focus();
    }
  }

  toggleClass() {
    this.showIconTarget.classList.toggle('d-none');
    this.hideIconTarget.classList.toggle('d-none');
  }
}
